module.exports = __webpack_public_path__ + "img/zhuanye-jilu.871cd979.svg";